import { render } from "./GradeRank.vue?vue&type=template&id=a5dec496&scoped=true"
import script from "./GradeRank.vue?vue&type=script&lang=js"
export * from "./GradeRank.vue?vue&type=script&lang=js"

import "./GradeRank.vue?vue&type=style&index=0&id=a5dec496&lang=less&scoped=true"

import exportComponent from "F:\\ypx\\zhiniao\\zhiniao-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5dec496"]])

export default __exports__